import {React, useState, useEffect} from 'react';
import { Link } from 'react-router-dom';


const DiagonalCircleMenu = () => {
    const [activeCircle, setActiveCircle] = useState(3);
    const [backgroundImage, setBackgroundImage] = useState(`url(/assets/images/home/Home_Explore_Thumbnail_BG90.png)`);
    const [largeCircleLabelText, setLargeCircleLabelText] = useState({title: 'Explore the Palace', subtitle: 'An Average Night', date:'2000'})
    const [targetLink, setTargetLink] = useState('#');

    // Update the large circle based on which small circle was last hovered over
    useEffect(() => {
        // Change background image
        setBackgroundImage([
            `url(/assets/images/home/Before_Thumbnail.jpg)`,
            `url(/assets/images/home/Building_Thumbnail.jpg)`,
            `url(/assets/images/home/Explore_Thumbnail.jpg)`,
            `url(/assets/images/home/Raid_Thumbnail.jpg)`,
            `url(/assets/images/home/After_Thumbnail.jpg)`
        ][activeCircle - 1]);

        // Change label text
        setLargeCircleLabelText([
            {title: 'Before the Palace', subtitle: 'Policing and Toronto\’s Queer Communities', date:'1974 - 1999'},
            {title: 'Building the Palace', subtitle: 'Radical Sex Organizing', date:'1998 - 2000'},
            {title: 'Explore the Palace', subtitle: 'An Average Night', date:'2000'},
            {title: 'Raid on the Palace', subtitle: 'Care, Resistance, and Recovery', date:'2000 - 2005'},
            {title: 'After the Palace', subtitle: 'Legacy, Activism, and Evolving Struggles ', date:'2025'}
        ][activeCircle - 1]);

        // Set the target link for navigation if clicked
        setTargetLink([
            '/before',
            '/building',
            '/explore/entrance',
            '/raid',
            '/after'
        ][activeCircle - 1]);

    }, [activeCircle])
    
    const onMouseEnterCover = e => setActiveCircle(Number(e.target.id.replace('circle-', '').replace('-cover', '')));
    
    const onClickCircle = (e) => {
        const url = e.currentTarget.getAttribute('data-url');
        if (url) {
            window.location.href = url;
        }
    };
    
    return (
        <div className="line-menu-container">
            <div id="large-circle-label">
                <div className='large-circle-label-title'>{largeCircleLabelText.title}</div>
                <div className='circle-title'>{largeCircleLabelText.subtitle}</div>
                <div className='circle-subtitle'>{largeCircleLabelText.date}</div>
            </div>
            <div id='diagonal'></div>
            <div id='circle-1-cover' data-url='/before' onMouseEnter={onMouseEnterCover} onClick={onClickCircle}></div>
            <div id='circle-2-cover' data-url='/building' onMouseEnter={onMouseEnterCover} onClick={onClickCircle}></div>
            <div id='circle-3-cover' data-url='/explore/entrance' onMouseEnter={onMouseEnterCover} onClick={onClickCircle}></div>
            <div id='circle-4-cover' data-url='/raid' onMouseEnter={onMouseEnterCover} onClick={onClickCircle}></div>
            <div id='circle-5-cover' data-url='/after' onMouseEnter={onMouseEnterCover} onClick={onClickCircle}></div>
            <div id='circle-1' className='small-circle'></div>
            <div id='circle-2' className='small-circle'></div>
            <div id='circle-3' className='small-circle'></div>
            <div id='circle-4' className='small-circle'></div>
            <div id='circle-5' className='small-circle'></div>
            <div id='circle-label-1' className='small-circle-label'>
                <div className='circle-title'>Before the Palace</div>
                <div className='circle-subtitle'>1974 - 1999</div>
            </div>
            <div id='circle-label-2' className='small-circle-label'>
                <div className='circle-title'>Building the Palace</div>
                <div className='circle-subtitle'>1998 - 2000</div>
            </div>
            <div id='circle-label-3' className='small-circle-label'>
                <div className='circle-title'>Explore the Palace</div>
                <div className='circle-subtitle'>2000</div>
            </div>
            <div id='circle-label-4' className='small-circle-label'>
                <div className='circle-title'>Raid on the Palace</div>
                <div className='circle-subtitle'>2000 - 2005</div>
            </div>
            <div id='circle-label-5' className='small-circle-label'>
                <div className='circle-title'>After the Palace</div>
                <div className='circle-subtitle'>2025</div>
            </div>
            <div id='large-circle' style={{backgroundImage: backgroundImage}} onClick={onClickCircle}></div> 
        </div>
    )
}

export default DiagonalCircleMenu;